import { IElementContainer } from "../../utils/ui/ElementContainer";
import { Authentication } from "../../auth/Authentication";
import { XHRLoader } from "../../utils/XHRLoader";
import { Main } from "../../Main";

export class ShareEmailView implements IElementContainer
{
	public element: HTMLElement;
	private _closeBtn: HTMLElement;
	private _sendBtn: HTMLElement;
	private _status: HTMLSpanElement;

	private _to: HTMLInputElement;
	//private _from: HTMLInputElement;
	private _subject: HTMLInputElement;
	private _message: HTMLTextAreaElement;

	private _openedMessage: string;

	constructor(elementId:string)
	{
		this.element = document.getElementById(elementId);

		this._closeBtn = <HTMLElement>this.element.querySelector('[data-id="auth_close"]');
		this._closeBtn.addEventListener("click", this.onCloseClick);

		this._sendBtn = <HTMLInputElement>this.element.querySelector('[data-id="sendBtn"]');

		this._status  = <HTMLSpanElement>this.element.querySelector('[data-id="status"]');
		this._to      = <HTMLInputElement>this.element.querySelector('[data-id="to"]');
		//this._from    = <HTMLInputElement>this.element.querySelector('[data-id="from"]');
		this._subject = <HTMLInputElement>this.element.querySelector('[data-id="subject"]');
		this._message = <HTMLTextAreaElement>this.element.querySelector('[data-id="message"]');
	}

	public show = (defaultMessage:string) =>
	{
		this._sendBtn.textContent = "Send";
		this._sendBtn.onclick = this.onSendClick;
		this.setStatus("");
		this._message.value = defaultMessage;

		this.element.style.display = "";
	};

	private onCloseClick = () =>
	{
		this.hide();
	}

	private hide = () =>
	{
		this.element.style.display = "none";
	};

	private onSendClick = () =>
	{
		var to      = this._to.value;
		//var from    = this._from.value;
		var subject = this._subject.value;
		var message = this._message.value;

		var validationError = "";

		if (!to)
		{
			validationError = "\"To\" can't be empty!";
		}
		//else if (!from)
		//{
		//	validationError = "\"From\" can't be empty!";
		//}
		else if (!subject)
		{
			validationError = "\"Subject\" can't be empty!";
		}
		else if (!message)
		{
			validationError = "\"Email\" can't be empty!";
		}

		this.setStatus(validationError);

		if (!validationError)
		{
			this.sendEmail(to, subject, message);
		}
	}

	private sendEmail(to: string, subject: string, message: string)
	{
		this.setStatus("Please wait...");
		this._sendBtn.classList.add("disabled");

		var url = Authentication.getPHPPath() + "send.php";
		var params = {
			from: Main.getInstance().authentication.email,
			to: to,
			subject: subject,
			message: message
		};

		XHRLoader.load({
			url: url,
			params: params,
			json: false,
			onComplete: this.onEmailComplete,
			onFail: this.onEmailFailHandler
		})
	}

	private onEmailComplete = (xhr, response) =>
	{
		if (xhr.responseText === "ok")
		{
			this._to.value = "";
			this._subject.value = "";
			this._message.value = "";

			this.setStatus("Email successfully sent!");
			this._sendBtn.textContent = "Close";
			this._sendBtn.onclick = this.onCloseClick;
			this._sendBtn.classList.remove("disabled");

		}
		else
		{
			this.onEmailFail();
		}
	}

	private onEmailFailHandler = (xhr, event) =>
	{
		this.onEmailFail();
	}

	private onEmailFail = () =>
	{
		this.setStatus("Something went wrong, please try again!");
		this._sendBtn.classList.remove("disabled");
	}

	private setStatus(text:string)
	{
		this._status.textContent = text;
	}
}
